import { useState } from 'react';
import { LayoutDashboard, Users, Car, LogOut, Tag, Euro, IdCard ,UserRoundPlus} from 'lucide-react';
import assets from '../Assets/assets';
import { useNavigate } from 'react-router-dom';
import ChangePasswordModal from './ChangePasswordModal';

const menu = [
  { label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard' },
  { label: 'User Management', icon: Users, path: '/users' },
  { label: 'Car Listings', icon: Car, path: '/car-listings' },
  { label: 'Bookings', icon: Tag, path: '/bookings' },
  { label: 'License Management', icon: IdCard, path: '/licenses' },
  { label: 'Add User', icon: UserRoundPlus, path: '/manage-user' },
  { label: 'Change Password', icon: UserRoundPlus, path: '/change-password' },
];

export default function Sidebar({ activeLabel, onMenuSelect }) {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const navigate = useNavigate()

  const openLogoutModal = () => setShowLogoutModal(true);
  const closeLogoutModal = () => setShowLogoutModal(false);
  const handleLogout = () => {
    setShowLogoutModal(false);
    navigate("/")
   localStorage.clear()
  };

  const openChangePasswordModal = () => setShowChangePasswordModal(true);
  const closeChangePasswordModal = () => setShowChangePasswordModal(false);

  const handleMenuSelect = (label, path) => {
    if (label === 'Change Password') {
      openChangePasswordModal();
    } else {
      onMenuSelect(label, path);
    }
  };
  const user_details = JSON.parse(localStorage.getItem("user_details"))

  return (
    <>
      <aside className="box-border flex flex-col items-start p-4 pt-4 gap-12 absolute w-[284px] min-h-screen left-0 top-0 bg-[#121212] font-[Poppins] border-e-[1px] border-[#454545]" style={{ fontFamily: 'Poppins, sans-serif' }}>
        {/* Logo */}
        <div className="flex flex-row items-center w-[244px] h-[85px] mb-2">
          <img src={assets.Logo} alt="Logo" className="w-[85px] h-[85px]" />
        </div>
        {/* Menu */}
        <div className="flex flex-col items-start w-[244px] gap-12 flex-1">
          <div className="flex flex-col gap-4 w-full">
            {menu.map(({ label, icon: Icon, path }) => (
              <div
                key={label}
                className={`flex flex-row items-center w-full px-2 py-[9px] h-[42px] cursor-pointer transition-all
                  ${activeLabel === label ? 'bg-gradient-to-b from-[#F3B7531A] to-[#EBE9E61A] border-l-[2px] border-[#F3B753] rounded-[7px]' : 'rounded-[4px]'}
                `}
                onClick={() => handleMenuSelect(label, path)}
              >
                <Icon className={`w-[16px] h-[16px] mr-3 ${activeLabel === label ? 'text-[#F3B753]' : 'text-[#454545]'}`} />
                <span className={`text-[14px] leading-[21px] font-normal flex-1 text-left ${activeLabel === label ? 'text-[#F3B753]' : 'text-[#454545]'}`}>{label}</span>
                <svg
                  className={`w-3 h-3 opacity-80 ${activeLabel === label ? 'stroke-[#F3B753]' : 'stroke-[#454545]'}`}
                  fill="none"
                  viewBox="0 0 12 12"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 3l3 3-3 3"
                    stroke="currentColor"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            ))}
          </div>
          {/* Divider */}
          <div className="w-full h-px bg-[#454545] opacity-40 my-2" />
          {/* Logout */}
          <div className="flex flex-col gap-6 w-full">
            <div
              onClick={openLogoutModal}
              className="flex flex-row items-center w-full px-2 py-[9px] h-[42px] rounded-[4px] cursor-pointer hover:bg-[#1e1e1e]"
            >
              <LogOut className="w-[16px] h-[16px] mr-3 text-[#454545]" />
              <span className="text-[14px] leading-[21px] font-normal flex-1 text-left text-[#454545]">Logout</span>
              <svg
                className="w-3 h-3 opacity-80 stroke-[#454545]"
                fill="none"
                viewBox="0 0 12 12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 3l3 3-3 3"
                  stroke="currentColor"
                  strokeWidth="0.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            {/* Admin Info */}
            <div className="flex flex-row items-center w-full px-2 gap-3">
              <div className="flex justify-center items-center w-8 h-8 bg-gradient-to-b from-[#F3B7531A] to-[#EBE9E61A] rounded-full">
                <img src="https://ui-avatars.com/api/?name=Pranshu&background=F3B753&color=fff&size=32" alt="Admin" className="w-8 h-8 rounded-full" />
              </div>
              <div className="flex flex-col justify-center">
                <span className="text-white text-[14px] font-medium leading-[21px]">{user_details?.first_name}</span>
                <span className="text-[#454545] text-[12px] font-medium leading-[18px]">Admin</span>
              </div>
            </div>
          </div>
        </div>
      </aside>

      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-50">
          <div className="bg-[#1A1A1A] rounded-xl shadow-lg w-[400px] p-6 text-center border border-[#F9AC1D] bg-gradient-to-b from-[#2b220fdb] to-[#18140bec]">
            {/* Icon */}
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F3B7531A]">
                <LogOut className="text-[#F3B753] w-6 h-6" />
              </div>
            </div>
            {/* Title */}
            <h2 className="text-lg font-semibold text-white mb-2">Logout</h2>
            <p className="text-sm text-gray-300 mb-6">
              Are you sure you want to logout?
            </p>
            {/* Buttons */}
            <div className="flex gap-4 justify-center">
              <button
                onClick={closeLogoutModal}
                className="flex-1 border border-[#F3B753] text-[#F3B753] py-3 rounded-lg font-medium text-sm hover:bg-[#F3B753] hover:text-black transition"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 bg-[#F3B753] text-black py-3 rounded-lg font-medium text-sm hover:bg-[#e6a800] transition"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      <ChangePasswordModal 
        isOpen={showChangePasswordModal} 
        onClose={closeChangePasswordModal} 
      />
    </>
  );
}
